import { Menu, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/solid';
import { ICountryInput } from '@types';
import classNames from 'classnames';
import Image from "next/legacy/image";
import { useRouter } from 'next/router';
import { Fragment, useState, useEffect } from 'react';

interface ISelectProps {
    onChange: (value: any) => void;
    initialCountryCode: string;
    countryList: ICountryInput[];
    isAuth?: boolean;
}

const ISelect: React.FC<ISelectProps> = ({ onChange, initialCountryCode, countryList, isAuth }) => {
    const [selectedCountry, setSelectedCountry] = useState<ICountryInput | undefined>(undefined);
    const { locale } = useRouter()

    useEffect(() => {
        if (initialCountryCode && countryList) {
            setSelectedCountry(countryList.find(c => c.dialcode === initialCountryCode));
        }
    }, [initialCountryCode, countryList]);

    const handleCountryChange = (country: ICountryInput) => {
        setSelectedCountry(country);
        onChange(country.dialcode);
    };



    return (
        <div className="w-max">
            <Menu as="div" className="relative inline-block text-left w-max">
                <div className={isAuth ? 'md:w-[100px] w-[100px]' : 'md:w-[135px] w-[120px]'}>
                    <Menu.Button className={classNames("inline-flex w-full items-center justify-between  rounded-2xl h-14 px-2 text-mui-text-primary focus:outline-none focus-visible:border-2 focus-visible:border-mui-primary-main", isAuth ? "bg-[#F5F5F5]" : "border border-[#0000003B]")}>
                        <div className="w-6 h-6 rounded-full relative overflow-hidden">
                            {selectedCountry?.image.url ? <Image src={selectedCountry?.image.url || ""} layout="fill" alt="" /> : null}
                        </div>
                        <p className={isAuth ? 'text-sm font-norma' : ''}>{selectedCountry?.dialcode}</p>
                        <ChevronDownIcon
                            className="-mr-1 ml-1 h-5 w-5"
                            aria-hidden="true"
                        />
                    </Menu.Button>
                </div>
                <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                >
                    <Menu.Items className="absolute left-0 mt-2 w-56 origin-top-right divide-y divide-mui-divider rounded-2xl shadow-elevation/2 bg-white focus:outline-none max-h-36 overflow-auto z-20" dir={locale?.includes("ar-") ? "rtl" : "ltr"}>
                        {countryList.map((c: ICountryInput) => (
                            <Menu.Item key={`country-${c.id}`}>
                                {({ active }) => (
                                    <div
                                        className={classNames("flex h-12 items-center cursor-pointer w-full pr-3 pl-2 gap-2", active ? "bg-mui-primary-hover" : "bg-white")}
                                        onClick={() => handleCountryChange(c)}
                                    >
                                        <div className="w-6 h-6 rounded-full relative overflow-hidden">
                                            <Image src={c.image.url} layout="fill" alt="" />
                                        </div>
                                        <p className="flex-1 text-sm text-mui-text-primary truncate flex justify-start">
                                            {c.name}
                                        </p>
                                        <bdi className="text-sm text-mui-text-primary">
                                            {c.dialcode}
                                        </bdi>
                                    </div>
                                )}
                            </Menu.Item>
                        ))}
                    </Menu.Items>
                </Transition>
            </Menu>
        </div>
    );
}

export default ISelect;

